/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Hubs_Signals_Faq_Buy_QInputs */

const en_directory_hubs_signals_faq_buy_q = /** @type {(inputs: Directory_Hubs_Signals_Faq_Buy_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I pay to raise my scores?`)
};

const zh_directory_hubs_signals_faq_buy_q = /** @type {(inputs: Directory_Hubs_Signals_Faq_Buy_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`付费能提高分数吗？`)
};

/**
* | output |
* | --- |
* | "Can I pay to raise my scores?" |
*
* @param {Directory_Hubs_Signals_Faq_Buy_QInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_hubs_signals_faq_buy_q = /** @type {((inputs?: Directory_Hubs_Signals_Faq_Buy_QInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Hubs_Signals_Faq_Buy_QInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_hubs_signals_faq_buy_q(inputs)
	return zh_directory_hubs_signals_faq_buy_q(inputs)
});
export { directory_hubs_signals_faq_buy_q as "directory.hubs.signals.faq.buy_q" }